import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'antd';
import { getIn } from 'formik';
import OfficeSearch from '@containers/filters/OfficeSearch';

function OfficeField(props) {
  const { field, form, label, ...restProps } = props;

  let error = getIn(form.errors, field.name);

  // if (Array.isArray(error)) {
  //   error = error[0];
  // }

  const touched = getIn(form.touched, field.name);
  const hasError = error !== undefined && !!touched;
  const isValid = !error && !!touched;

  const { name, value } = field;

  const handleChange = newValue => {
    form.setFieldValue(name, newValue);
  };

  const handleBlur = () => {
    form.setFieldTouched(name);
  };

  return (
    <Form.Item
      validateStatus={hasError ? 'error' : undefined}
      hasFeedback={isValid}
      label={label}
      help={(hasError && <li>{error}</li>) || (isValid && '')}
    >
      <OfficeSearch
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        {...restProps}
      />
    </Form.Item>
  );
}
OfficeField.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  label: PropTypes.string,
  innerLabel: PropTypes.string,
  minLen: PropTypes.number
};
export default OfficeField;
